import { Case } from '@debbie/common/dist/cases/index.js'
import * as paymentPlanHelpers from '@debbie/common/dist/economy/payment-plans/index.js'
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js'
import { c, h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { useTenant } from '@debbie/cortex/dist/tenant/index.js'
import { Panel } from '@debbie/iris/dist/components/index.js'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import DebtorInfo from './DebtorInfo.js'

interface Props {
  singleCase: Case
  onSkip: () => void
}

const GatherInfoStep = (props: Props) => {
  const { singleCase } = props

  const lang = useSelector((s: RootState) => s.lang)
  const tenant = useTenant()
  const creditorLoadable = useCreditor(singleCase?.creditorId)
  const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null

  const paymentPlanConfig = paymentPlanHelpers.resolvePaymentPlansConfig(
    creditor?.paymentPlansConfig,
    tenant?.paymentPlansConfig,
  )

  return (
    <Panel header={lang.debtorWebPaymentPlans.gatherInfo}>
      {
        <div>
          <p>{lang.debtorWebPaymentPlans.signTextThree}</p>
          <DebtorInfo
            caseId={singleCase.caseId}
            required
            skippable
            onSkip={props.onSkip}
            requireCentralRegisterId={
              paymentPlanConfig.requireCentralRegisterId
            }
          />
        </div>
      }
    </Panel>
  )
}

export default GatherInfoStep
